import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";

const Footer = () => {
    return (
        <React.Fragment>
            <footer className="footer footer-enhanced">
                <Container fluid>
                    <Row className="align-items-center">
                        <Col sm={6} className="footer-left">
                            <p className="footer-text">
                                {new Date().getFullYear()} © <span className="footer-brand">JA EVAL</span>
                            </p>
                        </Col>
                        <Col sm={6} className="footer-right">
                            <div className="text-sm-end footer-links">
                                <p className="footer-text">
                                    Développé par <a href="https://ideracloud.com" target="_blank" rel="noopener noreferrer" className="footer-link">IDERACLOUD</a> en partenariat avec <a href="#" target="_blank" rel="noopener noreferrer" className="footer-link">YALILA GROUP</a>
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;
